import { createAction, props } from '@ngrx/store';
import { Country } from '../Clubs/clubs.model';
import { Mutation } from './mutation.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records mutation'
);

export const fetchRecordsSuccess = createAction(
    '[Data] fetch records mutation success', 
    props<{ listData: Mutation[], total: number }>()
);

export const fetchRecordsFail = createAction(
    '[Data] fetch records mutation failure', 
    props<{ error: string }>()
);


// Update Data
export const updateRecord = createAction(
    '[Data] Update record mutation',
    props<{ id: string }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record mutation success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record mutation failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state mutation',
);